import { gql } from "@apollo/client";

import { createQueryHandler } from "@/client/graphql/createQueryHandler";
import type { SideBar_FactoryFieldsFragment } from "@/client/graphql/types/generated";
import { SideBar_FactoryFieldsFragmentDoc } from "@/client/graphql/types/generated";
import { makeSequentialComponent as makeSC } from "@/utils/sequential-component";

const GET_FACTORY_VIEWER = gql`
  ${SideBar_FactoryFieldsFragmentDoc}

  query SideBarIcon_GetFactoryViewer {
    me {
      ...SideBar_FactoryFields
    }
  }
`;
const factoryQuery = createQueryHandler<{}, { me: SideBar_FactoryFieldsFragment }>(
  GET_FACTORY_VIEWER,
);

export const SC = makeSC(factoryQuery, {
  swr: true,
});
